import { useState } from "react";
import { useSelector } from "react-redux";
import Tooltip from "../../../../components/tooltip";
import SurplusDeficitAnalysis from "./Generation/BuySellMainIndex";
import SimulationHeader from "../utility/SimulationHeader";
import { ErrorPopup } from "../../../../components/ErrorHandling";
import { ChartAreaLoader } from "../../../../components/Loading";
import PowerInjectionAnalysis from "./Generation/DayWiseInjectionChart/PowerInjectionchart";
import SummaryPopup from "./Popups/Summary_Index";
import SimulationSummaryTiles from "./SimulationSummaryTiles";

const DataTabs = ["Volume", "Cost"];
const MainTabs = ["Simulation", "Optimal", "Metrics"];

export default function PowerAnalytics() {
  const [activeMainTab, setActiveMainTab] = useState(MainTabs[0]);
  const [error, setError] = useState<string | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedBlock, setSelectedBlock] = useState<any[]>([]);
  const [uniqueTargetDate, setUniqueTargetDate] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [isSummaryPopupOpen, setIsSummaryPopupOpen] = useState(false);
  const [activeTab, setActiveTab] = useState<string>(DataTabs[0]);

  const DefaultDates = useSelector((state: any) => state.defaultDatesSetter.defaultDates);

  // Exchange and Market filter state
  const [selectedExchanges, setSelectedExchanges] = useState<string[]>(["IEX"]);
  const [selectedMarkets, setSelectedMarkets] = useState<string[]>(["DAM"]);

  // Date filter state (lifted from SimulationSummaryTiles for header SearchBox)
  const [selectedFilterDate, setSelectedFilterDate] = useState<any[]>([]);

  // Note: Date selection is now handled directly in each child component
  // via Redux (like Discom_Analysis.tsx pattern) and availableDates

  return (
    <>
      <div className="w-full overflow-hidden">
        <div className="h-[calc(-93px+100vh)] p-2 overflow-hidden">
          <div className="w-full h-full flex flex-col gap-2 overflow-hidden">
            <SimulationHeader
              onSummaryClick={() => setIsSummaryPopupOpen(true)}
              selectedExchanges={selectedExchanges}
              setSelectedExchanges={setSelectedExchanges}
              selectedMarkets={selectedMarkets}
              setSelectedMarkets={setSelectedMarkets}
              availableDates={DefaultDates?.["Power Market"]?.defaultTrendDates || []}
              selectedFilterDate={selectedFilterDate}
              setSelectedFilterDate={setSelectedFilterDate}
            />
            {/* SimulationSummaryTiles now fetches its own data based on availableDates */}
            <SimulationSummaryTiles
              availableDates={DefaultDates?.["Power Market"]?.defaultTrendDates || []}
              selectedExchanges={selectedExchanges}
              selectedMarkets={selectedMarkets}
              selectedFilterDate={selectedFilterDate}
              setSelectedFilterDate={setSelectedFilterDate}
            />
            <div className="flex flex-row gap-4 relative flex-1 min-h-0 overflow-hidden">
              <div
                className="gas-chart-container !p-0 shadow-[rgba(149,157,165,0.2)_0px_8px_24px] rounded-2xl flex flex-col min-w-0"
                style={{
                  height: "100%",
                  flex: 1,
                  overflow: "hidden",
                }}
              >
                {activeMainTab === "Simulation" && (
                  <div className="flex flex-col h-full w-full min-w-0 overflow-hidden">
                    {/* Content area - Takes remaining height */}
                    <div className="flex flex-col gap-3 flex-1 min-h-0 min-w-0 overflow-hidden !bg-[#FCFCFCB8]">
                      {/* Metrics Cards Row - Auto height based on content */}
                      <div className="grid grid-cols-1 gap-2 min-w-0 overflow-hidden">
                        <div className="w-full flex-shrink-0 min-w-0 overflow-hidden">
                          <PowerInjectionAnalysis
                            selectedBlock={selectedBlock}
                            setSelectedBlock={setSelectedBlock}
                            refreshKey={refreshKey}
                            setError={setError}
                            setUniqueTargetDate={setUniqueTargetDate}
                            selectedExchanges={selectedExchanges}
                            selectedMarkets={selectedMarkets}
                          />
                        </div>
                      </div>

                      {/* Charts Row - Takes remaining space */}
                      <div className="w-full flex-1 min-h-0 min-w-0 overflow-hidden">
                        <SurplusDeficitAnalysis
                          selectedBlock={selectedBlock}
                          refreshKey={refreshKey}
                          setError={setError}
                          setUniqueTargetDate={setUniqueTargetDate}
                          activeTab={activeTab}
                          selectedExchanges={selectedExchanges}
                          selectedMarkets={selectedMarkets}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <ErrorPopup error={error} onClose={() => setError(null)} />
        <SummaryPopup
          isOpen={isSummaryPopupOpen}
          onClose={() => setIsSummaryPopupOpen(false)}
          selectedExchanges={selectedExchanges}
          selectedMarkets={selectedMarkets}
        />
  <div className="gna-footer-container">
          <div className="grid grid-cols-3 justify-between gap-5 ">
            <Tooltip note={<p>Power Analysis</p>} text=" ">
              <p className="gna-footer-text">Source</p>
            </Tooltip>
            <p className="gna-footer-text col-span-1 text-center">
              Powered by <strong>GNA Energy</strong>
            </p>
            <strong className="gna-footer-text col-span-1 text-end">
              Beta Version
            </strong>
          </div>
        </div>
      </div>
    </>
  );
}
